/** @format */

import { IScoreCardSkuResponse, ProcessedProduct } from '@shared/data-access/interfaces';

import { IScoreCardSkuRequest } from './scorecard-sku-request.interface';
import { inject, Injectable } from '@angular/core';
import { LoyaltyDao } from './loyalty.dao';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoyaltyService {
  private readonly loyaltyDao = inject(LoyaltyDao);

  /**
   * @description
   * Registers the given email address with Loyalty
   */
  public registerEmailAddressForLoyalty$(emailAddress: string, retries?: number): Observable<any> {
    return this.loyaltyDao.registerEmailAddressForLoyalty$(emailAddress, retries);
  }

  /**
   * @description
   * get eligibility of given list of skus and prices
   */
  public getScorecardSkuEligibility(
    product: ProcessedProduct,
  ): Observable<IScoreCardSkuResponse[]> {
    const Skus: IScoreCardSkuRequest[] = [];
    if (product.skus) {
      for (const sku of product.skus) {
        Skus.push({
          sku: sku.partNumber,
          price: sku.prices.offerPrice.toString(),
        });
      }
    }
    return this.loyaltyDao.getScorecardSkuEligibility(Skus);
  }
}
